export default __webpack_public_path__ + "static/media/cx_cover_lnn3.23582303.jpg";